let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9ftJe"), load("7lNQq"), load("gGSRo")]).then(() => parcelRequire('cqeVP'));